import { AuthSelectors } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import ExerciseCard from '../components/ExerciseCard/ExerciseCard';
import { SessionSelectors } from '../session';
import { IState } from '../store/state';

interface IOwnProps {
  // workout id
  workoutId: number;
  // index of workout in the current session
  index: number;
}

export interface ISessionExerciseProps extends IOwnProps {
  // name of the exercise for the workout (defines title and icon)
  exerciseId: string | null;
  // show checkmark instead of the icon if completed and other styles
  completed: boolean;
  // histogram comparison value for given workout
  comparison: number | null;
  // locked flag
  locked?: boolean;
  isModerator: boolean;
}

export const SessionExerciseFC: React.FC<ISessionExerciseProps> = ({
  workoutId,
  exerciseId,
  completed,
  comparison,
  locked,
  index,
  isModerator,
}) => {
  const cardProps = {
    exerciseId,
    comparison,
    locked,
    completed,
    workoutId,
    className: 'session-exercise-card col-6',
    sessionArrayIndex: index,
    id: `${index}-${workoutId}`,
    subtitle: isModerator ? `${exerciseId}-${workoutId}` : undefined,
  };
  return <ExerciseCard {...cardProps} />;
};

export const mapStateToProps = (state: IState, { index, workoutId }: IOwnProps) => {
  const exerciseId = SessionSelectors.getExerciseName(state, workoutId);
  const completed = SessionSelectors.isWorkoutCompleted(state, index);
  const comparison = SessionSelectors.getWorkoutComparison(state, workoutId);
  const locked = !!SessionSelectors.isWorkoutLocked(state, workoutId);
  const isModerator = AuthSelectors.isModerator(state);
  return {
    exerciseId,
    completed,
    comparison,
    locked,
    isModerator,
  };
};

const SessionExercise = connect(mapStateToProps)(SessionExerciseFC);
export default SessionExercise;
